import React from "react";
import '../styles/Vision.css';
import ourVision from '../../../Images/our-vision.png'
import HomePageContent from "./HomePageContent";


const Vision = () => {

    return (
        <section className="our-vision" id="our-vision">
            <div className="our-vision-container">
                <div className="our-vision-image">
                    <img src={ourVision} alt="Our Vision" />
                </div>
                <div className="our-vision-content">
                    <div className="our-vision-title"><p>{HomePageContent.Our_Vision_Title}</p>
                    </div>
                    <div className="our-vision-body">{HomePageContent.our_Vision_Content} </div>
                </div>


            </div>


        </section>

    )

}

export default Vision;